// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"4fce6352","453":"668e601c","629":"fb9a35f3"}[chunkId] + ".chunk.js";
};